import { fadeIn, fadeOut } from "../utils/fade"

export class FeatureItems {
  /**
   * @param {string} selector
   * @param {object} options
   */
  constructor(selector, options = {}) {
    const defaultOptions = {
      buttonSelector: ".btn",
      cardWrapSelector: ".features-body_card-wrap",
      cardSelector: ".features-body_card",
      initiallyVisibleCount: 999,
      fadeDuration: 300,
      fadeDisplay: "flex",
    }

    this.settings = { ...defaultOptions, ...options }
    this.containers = document.querySelectorAll(selector)

    if (this.containers.length > 0) {
      this.init()
    }
  }

  init() {
    this.containers.forEach((container) => {
      const showBtn = container.querySelector(this.settings.buttonSelector)
      const cardWrap = container.querySelector(this.settings.cardWrapSelector)
      const cards = cardWrap ? cardWrap.querySelectorAll(this.settings.cardSelector) : []

      // console.log(showBtn)
      // console.log(cardWrap)
      // console.log(cards)

      if (!showBtn || cards.length === 0) return

      this.setupInitialState(showBtn, cards)
      showBtn.addEventListener("click", () => this.toggleCards(showBtn, cards))
    })
  }

  setupInitialState(button, cards) {
    const { initiallyVisibleCount } = this.settings

    if (cards.length > initiallyVisibleCount) {
      cards.forEach((card, index) => {
        if (index >= initiallyVisibleCount) {
          card.classList.add("hide")
        }
      })
      button.classList.remove("hidden")
      button.dataset.state = "show-all"
      button.textContent = button.getAttribute("data-text-show")
    } else {
      button.classList.add("hidden")
    }
  }

  toggleCards(button, cards) {
    const { fadeDuration, fadeDisplay, initiallyVisibleCount } = this.settings
    const textShow = button.getAttribute("data-text-show")
    const textHide = button.getAttribute("data-text-hide")

    if (button.dataset.state === "show-all") {
      cards.forEach((card, index) => {
        if (card.classList.contains("hide")) {
          setTimeout(() => {
            fadeIn(
              card,
              fadeDuration,
              () => {
                card.classList.remove("hide")
              },
              fadeDisplay,
            )
          }, (index - initiallyVisibleCount) * 100)
        }
      })
      button.dataset.state = "show-less"
      button.textContent = textHide
    } else {
      cards.forEach((card, index) => {
        if (index >= initiallyVisibleCount) {
          fadeOut(card, fadeDuration, () => {
            card.classList.add("hide")
          })
        }
      })
      button.dataset.state = "show-all"
      button.textContent = textShow
    }
  }
}
